import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export function useResendConfirmationEmail() {
  const { notifyError, notifySuccess } = useNotification();
  const { t } = useTranslation(['userSettings']);

  return ({ email }: { email: string }) => {
    const requestURL = '/send-confirmation-email';
    const form = new FormData();
    form.append('email', email);
    return request(requestURL, {
      method: 'POST',
      body: form,
    })
      .then(() => {
        notifySuccess({
          title: t('userSettings:messages.confirmEmailSuccess'),
        });
      })
      .catch(() => {
        notifyError({
          title: t('userSettings:messages.confirmEmailError'),
        });
      });
  };
}
